var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:[
        {
            phone: _vm.systemInfo.screenView === 'phone',
            pad: _vm.systemInfo.screenView === 'pad',
            desktop: _vm.systemInfo.screenView === 'desktop',
        },
    ],attrs:{"id":"app"}},[_c('router-view',{staticClass:"view"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }